import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ClickOutsideDirective } from 'thkee-common';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, AngularSvgIconModule, ClickOutsideDirective],
})
export class NavigationComponent {
  @Input() openNavigation: boolean = false;
  @Input() position: string = 'left';
  @Input() contentClass: string = '';

  showDropdown: boolean = false;

  handleClickOutside() {
    this.showDropdown = false;
  }
}
